import { Link } from 'react-router-dom';
import { ShieldCheck, Users, MessageSquareOff, ArrowRight } from 'lucide-react';
import Header from '../components/Header';

export default function ForTradies() {
  return (
    <div className="min-h-screen bg-[#FAF9F6]" data-testid="for-tradies-page">
      <Header />
      <section className="border-b border-[#E5E4E0]">
        <div className="mx-auto grid max-w-6xl grid-cols-1 gap-12 px-6 py-16 md:px-10 md:py-24 lg:grid-cols-2">
          <div>
            <div className="text-xs font-semibold uppercase tracking-[0.3em] text-[#D96C4E]">For trades</div>
            <h1 className="mt-6 font-heading text-5xl font-bold leading-[1.05] tracking-tight text-[#1C1B1A] md:text-6xl">
              A directory that respects your time.
            </h1>
            <p className="mt-6 max-w-lg text-lg text-[#5C5B5A]">
              No lead auctions. No pay-per-quote. Genuine locals call you directly.
              Plus a private tradie back-office with tools built specifically for the ute-and-toolbox reality of your day.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/register" className="btn-primary" data-testid="for-tradies-signup">Create free listing <ArrowRight size={16} /></Link>
              <Link to="/login" className="btn-ghost">Already listed? Sign in</Link>
            </div>
          </div>
          <div className="space-y-4">
            {[
              { icon: <ShieldCheck size={22} />, title: 'Get verified', body: 'We manually check every profile so consumers know you\u2019re legit.' },
              { icon: <MessageSquareOff size={22} />, title: 'Direct enquiries', body: 'Your phone and email are on your profile. Homeowners contact you directly — no one skimming in between.' },
              { icon: <Users size={22} />, title: 'Verified-only community', body: 'Once you\'re verified, you join a private tradie community. What happens inside stays inside — no consumers, no scrapers, no public view.' },
            ].map((f) => (
              <div key={f.title} className="flex gap-4 border border-[#E5E4E0] bg-white p-6">
                <div className="text-[#1A362D]">{f.icon}</div>
                <div>
                  <div className="font-heading text-xl font-bold text-[#1C1B1A]">{f.title}</div>
                  <div className="mt-1 text-sm text-[#5C5B5A]">{f.body}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
